
import Vue from "vue";
import moment from "moment";
import AgregarRegistros from "../../components/admin/AgreagarRegistros.vue";
import Agenda from "@/views/Agenda.vue";

export default Vue.extend({
  components: { AgregarRegistros, Agenda },
  props: ["modal"],
  mounted() {
    this.$http
      .get(`Registro/${this.modal.userId}`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
      .then(res => (this.datos = res.data));
  },
  data() {
    return {
      agregarRegistro: false,
      datos: {
        registros: [] as Array<{ id: string; horaInicio: string; horaFin: string; justificante_start: string; justificante_end: string }>,
        nombreUsuario: "",
      },
      registroSeleccionado: {
        id: "",
        fecha: "",
        start: "",
        end: "",
        justificante_start: "",
        justificante_end: "",
        user_id: this.modal.userId
      }
    };
  },
  methods: {
    formatDate(fecha: string) {
      const d = moment(fecha, "MM/DD/YYYY").format("DD/MM/YYYY");
      return d === "Invalid date" ? fecha : d;
    },

    formatTrabajado(fecha: string) {
      const horas = fecha[0] == "0" ? fecha.slice(1, 2) : fecha.slice(0, 2)
      const minutos = fecha[3] == "0" ? fecha.slice(4, 5) : fecha.slice(3, 5)
      return horas + "h y " + minutos + "min"
    },
    agregaRegistro() {
      this.agregarRegistro = false;
      this.registroSeleccionado = {
        id: "",
        fecha: "",
        start: "",
        end: "",
        justificante_start: "",
        justificante_end: "",
        user_id: this.modal.userId
      };
      setTimeout(() => this.agregarRegistro = true, 1000);
    },
    modificaRegistro(id, fecha, inicio, final, mensajeEntrada, mensajeSalida) {
      this.agregarRegistro = false;
      setTimeout(() => { this.obtieneVariables(id, fecha, inicio, final, mensajeEntrada, mensajeSalida); }, 1000);
    },
    obtieneVariables(id, fecha, inicio, final, mensajeEntrada, mensajeSalida) {
      this.registroSeleccionado.id = id;
      this.registroSeleccionado.fecha = fecha;
      this.registroSeleccionado.start = inicio;
      this.registroSeleccionado.end = final;
      this.registroSeleccionado.justificante_start = mensajeEntrada;
      this.registroSeleccionado.justificante_end = mensajeSalida;

      this.agregarRegistro = true;
    },
    recibirDatosActualizados(e: { id: string; start: string; end: string, justificante_start: string, justificante_end: string }) {
      const registroActualizado = this.datos.registros.find(registro => registro.id === e.id);

      if (registroActualizado) {
        registroActualizado.horaInicio = e.start;
        registroActualizado.horaFin = e.end;
        registroActualizado.justificante_start = e.justificante_start;
        registroActualizado.justificante_end = e.justificante_end;
      }
    }
  }
});
